<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="92%" append-to-body @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="readonly && form.voucherId" class="doc-dialog-actions">
          <el-button-group>
            <el-button v-if="isAuth('finance:voucher:approve') && form.approveStatus !== '2'" type="primary" size="small" @click="approve(form, true)">记账</el-button>
            <el-button v-if="isAuth('finance:voucher:unapprove') && form.approveStatus === '2' && !Number(form.managedVoucher)" type="primary" size="small" @click="approve(form, false)">弃审</el-button>
            <el-button v-if="!Number(form.managedVoucher) && (isAuth('finance:voucher:update') || isAuth('finance:voucher:save'))" type="primary" size="small" :disabled="!canEditDoc" @click="editFromView">修改</el-button>
            <el-button v-if="!Number(form.managedVoucher) && (isAuth('finance:voucher:delete') || isAuth('finance:voucher:save'))" type="danger" size="small" :disabled="!canEditDoc" @click="deleteFromView">删除</el-button>
          </el-button-group>
        </div>
      </div>
    </template>
    <el-alert v-if="readonly && Number(form.managedVoucher)" type="info" :closable="false" show-icon
      title="该凭证由业务单据或损益结转生成，请在来源单据操作；未记账时可在此记账。" style="margin-bottom:12px" />
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : rules" :disabled="readonly" label-width="90px">
      <el-row :gutter="16">
        <el-col :span="6">
          <el-form-item label="凭证号" prop="voucherCode">
            <el-input v-model="form.voucherCode" :disabled="!!form.voucherId" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="凭证日期" prop="voucherDate">
            <el-date-picker v-model="form.voucherDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="凭证字">
            <el-select v-model="form.voucherType" style="width:100%">
              <el-option label="记" value="记" />
              <el-option label="收" value="收" />
              <el-option label="付" value="付" />
              <el-option label="转" value="转" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="附件数">
            <el-input-number v-model="form.attachmentCount" :min="0" style="width:100%" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注">
        <el-input v-model="form.remark" />
      </el-form-item>
      <div v-if="!readonly" style="margin-bottom:8px">
        <el-button type="primary" size="small" @click="addLine">增行</el-button>
      </div>
      <el-table v-if="!readonly || (form.lines && form.lines.length)" border :data="form.lines" :header-cell-style="headStyle">
        <el-table-column type="index" label="序号" width="55" align="center" />
        <el-table-column label="摘要" min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.summary" size="small" />
          </template>
        </el-table-column>
        <el-table-column label="科目" min-width="220">
          <template slot-scope="scope">
            <el-select v-model="scope.row.financeSubjectId" filterable size="small" style="width:100%" @change="val => onSubject(scope.row, val)">
              <el-option v-if="scope.row.financeSubjectId && !subjectKnown(scope.row.financeSubjectId)"
                :label="(scope.row.subjectCode || '') + ' ' + (scope.row.subjectName || '原科目已失效')"
                :value="scope.row.financeSubjectId" disabled />
              <el-option v-for="s in subjects" :key="s.financeSubjectId" :label="s.subjectCode + ' ' + s.subjectName" :value="s.financeSubjectId" :disabled="String(s.isLeaf) !== '1' || String(s.isenabled) !== '0'" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="借方金额" width="150">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.debitAmount" :min="0" :precision="2" size="small" style="width:100%" @change="onAmount(scope.row, 'debit')" />
          </template>
        </el-table-column>
        <el-table-column label="贷方金额" width="150">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.creditAmount" :min="0" :precision="2" size="small" style="width:100%" @change="onAmount(scope.row, 'credit')" />
          </template>
        </el-table-column>
        <el-table-column v-if="!readonly" label="操作" width="60" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="form.lines.splice(scope.$index, 1)">删</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:8px;text-align:right">
        借方合计：<b>{{ readonly && !(form.lines && form.lines.length) ? money(form.totalDebit) : totalDebit }}</b>　贷方合计：<b>{{ readonly && !(form.lines && form.lines.length) ? money(form.totalCredit) : totalCredit }}</b>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import auth from './financeAuth'

function line() {
  return { summary: '', financeSubjectId: '', subjectCode: '', subjectName: '', debitAmount: 0, creditAmount: 0 }
}

export default {
  name: 'VoucherAddOrUpdate',
  mixins: [auth],
  data() {
    return {
      visible: false,
      readonly: false,
      subjects: [],
      form: { voucherCode: '', voucherDate: '', voucherType: '记', attachmentCount: 0, remark: '', lines: [] },
      rules: {
        voucherCode: [{ required: true, message: '凭证号不能为空', trigger: 'blur' }],
        voucherDate: [{ required: true, message: '凭证日期不能为空', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看凭证'
      return this.form.voucherId ? '修改凭证' : '新增凭证'
    },
    totalDebit() {
      return (this.form.lines || []).reduce((s, l) => s + Number(l.debitAmount || 0), 0).toFixed(2)
    },
    totalCredit() {
      return (this.form.lines || []).reduce((s, l) => s + Number(l.creditAmount || 0), 0).toFixed(2)
    }
  },
  methods: {
    blank() {
      return { voucherCode: '', voucherDate: this.today(), voucherType: '记', attachmentCount: 0, remark: '', lines: [line(), line()] }
    },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.loadSubjects()
      if (!id) {
        this.form = this.blank()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/finance/voucher/info', { params: { id } }).then(res => {
        const row = res.data || {}
        this.form = Object.assign({ lines: [] }, row)
        if (!Array.isArray(this.form.lines)) this.form.lines = []
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() {
      this.form = this.blank()
      this.readonly = false
    },
    loadSubjects() {
      request.get('/finance/subject/list').then(res => { this.subjects = res.data || [] }).catch(() => {})
    },
    subjectKnown(id) {
      return this.subjects.some(s => s.financeSubjectId === id)
    },
    editFromView() {
      if (Number(this.form.managedVoucher)) return
      if (!this.assertCanEditDoc('edit')) return
      this.readonly = false
    },
    deleteFromView() {
      if (Number(this.form.managedVoucher)) return
      if (!this.assertCanEditDoc('delete')) return
      this.$confirm('确定删除该凭证?', '提示', { type: 'warning' }).then(() => {
        request.post('/finance/voucher/delete', { id: this.form.voucherId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },
    addLine() { this.form.lines.push(line()) },
    onSubject(row, id) {
      const hit = this.subjects.find(s => s.financeSubjectId === id)
      row.subjectCode = hit ? hit.subjectCode : ''
      row.subjectName = hit ? hit.subjectName : ''
    },
    onAmount(row, side) {
      if (side === 'debit' && Number(row.debitAmount) > 0) row.creditAmount = 0
      if (side === 'credit' && Number(row.creditAmount) > 0) row.debitAmount = 0
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        if (this.form.lines.length < 2) {
          this.$message.warning('凭证至少需要2行分录')
          return
        }
        if (this.totalDebit !== this.totalCredit) {
          this.$message.warning('凭证借贷不平衡')
          return
        }
        request.post('/finance/voucher/save', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    },
    approve(row, pass) {
      const url = pass ? '/finance/voucher/approve' : '/finance/voucher/unapprove'
      this.$confirm(pass ? '确定记账?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {
        request.post(url, { id: row.voucherId }).then(() => {
          this.$message.success(pass ? '记账成功' : '弃审成功')
          if (row && this.form && row.voucherId && this.form.voucherId === row.voucherId) {
            this.$set(this.form, 'approveStatus', pass ? '2' : '0')
            this.readonly = true
          }
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
</style>
